import React from 'react';
import { AuthProvider } from './auth';
import { DisplayProvider } from './display';
import { MeProvider } from './me';
interface ContextFnProps {
  children: React.ReactNode;
}

function AppProvider({ children }: ContextFnProps) {
  return (
    <DisplayProvider>
      <AuthProvider>
        <MeProvider>
          {children}
        </MeProvider>
      </AuthProvider>
    </DisplayProvider>

  );
}

export default AppProvider;
